import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import LanguageCMSModel from '@/visa-application/models/LanguageCMSModel';
import CurrencyCMSModel from '@/visa-application/models/CurrencyCMSModel';
import ConsentCMSModel from '@/visa-application/models/ConsentCMSModel';

export default class CountryCMSModel implements CMSModel {
  code = '';
  country_redirection = '';
  name = '';
  availableLanguages: LanguageCMSModel[] = [];
  defaultLanguage: LanguageCMSModel = undefined;
  country_name_translation: string;
  marketing_consent: ConsentCMSModel = new ConsentCMSModel();
  hide_duplicate_button = false;
  hide_doclist_download = false;
  hide_new_add_application_button = false;
  country_copyrights = '';
  view_form = false;

  map(obj: any): void {
    this.code = _.get(obj, 'code', '');
    this.country_redirection = _.get(obj, 'country_redirection', '');
    this.name = _.get(obj, 'name', '');
    this.availableLanguages = _.map(obj.available_languages, 'languages_id');
    this.defaultLanguage = _.get(obj, 'default_language', '');
    this.country_name_translation = _.get(obj, 'translation[0].country_name_translation', '');
    this.marketing_consent.map(_.get(obj, 'marketing_consent', undefined));
    this.hide_duplicate_button = _.get(obj, 'hide_duplicate_button', false);
    this.hide_doclist_download = _.get(obj, 'hide_doclist_download', false);
    this.hide_new_add_application_button = _.get(obj, 'hide_new_add_application_button', false);
    this.country_copyrights = _.get(obj, 'translation[0].country_copyrights', '');
    this.view_form = _.get(obj, 'view_form', false);
  }
}
